import React, {useState} from 'react';
import styled, {createGlobalStyle} from 'styled-components';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import Benefits from './components/Benefits/Benefits';
import HowItWorks from './components/HowItWorks/HowItWorks';
import PostStructure from './components/PostStructure/PostStructure';
import Tariffs from './components/Tariffs/Tariffs';
import StartGuide from './components/StartGuide/StartGuide';
import TrialModal from './components/TrialModal/TrialModal';
import Footer from './components/Footer/Footer';

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    padding: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    background-color: #f1f5f9;
    color: #1e293b;
    -webkit-font-smoothing: antialiased;
  }
`;

const AppContainer = styled.div`
  max-width: 1024px;
  margin: 0 auto;
  background-color: #ffffff;
  min-height: 100vh;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  position: relative;
`;

export default function App() {
    const [isTrialOpen, setIsTrialOpen] = useState(false);
    const [tariffId, setTariffId] = useState(null);

    const handleOpenTrial = (tariffId) => {
        setTariffId(tariffId);
        setIsTrialOpen(true);
    };

    const handleCloseTrial = () => {
        setIsTrialOpen(false);
    };

    const handleScrollToTariffs = () => {
        const section = document.getElementById('tariffs-section');
        if (section) {
            section.scrollIntoView({behavior: 'smooth'});
        }
    };

    return (
        <>
            <GlobalStyle/>
            <AppContainer>
                <Header onOpenTrial={() => handleOpenTrial()}/>
                <main>
                    <Hero onOpenTrial={() => handleOpenTrial()} onScrollToTariffs={handleScrollToTariffs}/>
                    <Benefits/>
                    <HowItWorks/>
                    <PostStructure/>
                    <Tariffs onOpenTrial={handleOpenTrial}/>
                    <StartGuide/>
                </main>
                <Footer/>
                <TrialModal tariff_id={tariffId} open={!!isTrialOpen} onClose={handleCloseTrial}/>
            </AppContainer>
        </>
    );
}
